module.exports = __webpack_public_path__ + "static/img/14010009.b1d328d9.png";